import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { AIMedia, UploadTypes } from '../../@types';

type Payload = {
  name?: string;
  type: UploadTypes;
  shouldFetchData?: boolean;
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  filters?: { [key: string]: any };
};

const getAllAiMediaData = async (payload: Payload): Promise<AIMedia[]> => {
  const res = await axiosInstance.post('/api/stock-gallery/get-ai-media', payload);
  return res.data;
};

export const useGetAllAiMediaData = (payload: Payload) => {
  return useInfiniteQuery(
    ['getAllAiMediaData', payload],
    ({ pageParam = 1 }) => getAllAiMediaData({ ...payload, page: pageParam }),
    {
      getNextPageParam: (lastPage, allPages) => {
        const currentPage = allPages.length;
        const currentPageDataLength = allPages[currentPage - 1].length;

        if (currentPageDataLength === payload?.limit) {
          return currentPage + 1;
        } else {
          return undefined;
        }
      },
    }
  );
};

export const useGetFiniteAiMediaData = (payload: Payload) => {
  return useQuery(['getAllAiMediaData', payload], () => getAllAiMediaData(payload), {
    enabled: payload?.shouldFetchData,
    keepPreviousData: true,
  });
};
